import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, formatApiError } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = loading; false = anon; object = authenticated.
    const [user, setUser] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get('/auth/me');
            setUser(data);
            return data;
        } catch {
            setUser(false);
            return null;
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password, remember = false) => {
        const { data } = await api.post('/auth/login', { email, password, remember });
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await api.post('/auth/logout');
        } catch {
            /* ignore */
        }
        setUser(false);
    };

    const value = { user, setUser, login, logout, refresh, formatApiError };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
}
